<div id="discharges-modal" class="common-popup-view sending-popup-fixer">
    <div class="popoup-hearder">
        <h2 class="m-b-5" mat-dialog-title>Altas</h2>
    </div>
    <form [formGroup]="dischargeForm">
        <div class="popoup-content">
            <div class="block-looper-wrapper">
                <div class="block-looper">
                    <fieldset id="Enviar" class="multi-date-wrap">
                        <legend></legend>
                        <div class="full">
                            <h2>Gestor</h2>
                            <mat-form-field appearance="fill">
                                <mat-select [(value)]="SelectedAdministrativeUser" formControlName="SelectedAdministrativeUser"
                                    (selectionChange)="onAdminUserChange($event)">
                                    <mat-option *ngFor="let user of admintrativeUsers" [value]="user.administrativa">
                                        {{user.nombre}}
                                    </mat-option>

                                </mat-select>


                            </mat-form-field>                     
                        </div>
                        
                    </fieldset>
                </div>

                <div class="block-looper">
                    <fieldset id="Enviar" class="multi-date-wrap">
                        <legend></legend>
                        <h2>Enviar a</h2>
                        <div class="three-view">
                            <label class="container-radio">Todos los médicos
                                <input type="radio" id="all" value="all" name="Enviar" formControlName="Enviar"
                                    (click)="enviarChangeHandler($event)">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="half">
                            <label class="container-radio">El medico
                                <input type="radio" id="single" value="single" name="Enviar" formControlName="Enviar"
                                    (click)="enviarChangeHandler($event)">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="full" *ngIf="hideElMedicoInput">
                            <mat-form-field appearance="fill">
                                <mat-select [(value)]="SelectedDoctor" panelClass="cus-search-select"  formControlName="SelectedDoctor"
                                    (selectionChange)="onDoctorChange($event)">
                                   

                                    <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                                        (input)="SearchDoctors()" />
                                        
                                    <div class="search-options">
                                        <mat-option *ngFor="let doctor of _medicoList" [value]="doctor.medicoId">
                                            {{doctor.nombre}}
                                        </mat-option>
                                    </div>
                                </mat-select>
                            </mat-form-field>
                            <mat-error
                                *ngIf="dischargeForm.get('SelectedDoctor').invalid && dischargeForm.get('SelectedDoctor').touched">
                                <span *ngIf="dischargeForm.get('SelectedDoctor').hasError('required')"> Se debe
                                    indicar el medico</span>
                            </mat-error>
                        </div>
                        <div class="full">
                            <div class="task-elimination-date">
                                <app-date-period-selector [IsBothDatesRequired]="true"
                                    [DateType]="DateFilterType.Common" [PeriodFrom]="getFormControl('DateFrom')"
                                    [PeriodTo]="getFormControl('DateTo')"
                                    (FromDateChanged)="setFilterValues('commonDateFrom', $event)"
                                    (ToDateChanged)="setFilterValues('commonDateTo', $event)"
                                    required-error-message="Se debe indicar el period"></app-date-period-selector>
                            </div>
                        </div>
                    </fieldset>

                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button mat-button color="primary" class="keep" (click)="onSubmit()"><span
                    class="mat-button-wrapper unset-position">Aceptar
                    <mat-icon *ngIf="IsCancelDissabled"><mat-spinner color="white" diameter="20">
                    </mat-spinner></mat-icon>
                </span></button>
            <button [disabled]="IsCancelDissabled" mat-button color="accent" class="cancel" (click)="close()"><span
                    class="mat-button-wrapper unset-position">Cancelar</span></button>
        </div>

        
    </form>
</div>